// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Kyrt","title":"Header_title__3rnWa","left":"Header_left__2Bm7A","clinicName":"Header_clinicName__10eHg"};